import psicologia from '../assets/feedback/1.FacultadDePsicologiaYRel.Humanas.pdf'
import economia from '../assets/feedback/2.FacultadDeCs.Economicas.pdf'
import derecho from '../assets/feedback/3.FacultadDeDerechoYCs.Politicas.pdf'
import comunicacion from '../assets/feedback/4.FacultadDeCs.DeLaComunicacion.pdf'
import arquitectura from '../assets/feedback/5.FacultadDeArquitectura.pdf'
import educacion from '../assets/feedback/6.FacultadDeCs.DeLaEducacionYPsicopedagogia.pdf'
import medicina from '../assets/feedback/7.FacultadDeMedicinaYCs.DeLaSalud.pdf'
import tecnologia from '../assets/feedback/8.FacultadDeTecnologiaInformatica.pdf'
import deporte from '../assets/feedback/9.FacultadDeMotricidadHumanaYDeportes.pdf'

const feedbackMap = {
  P: psicologia,
  C: economia,
  J: derecho,
  I: comunicacion,
  A: arquitectura,
  E: educacion,
  M: medicina,
  T: tecnologia,
  D: deporte,
};

export const getFeedbackFileUrl = (codFaculty) => {
  if (!codFaculty) return null;

  return feedbackMap[codFaculty?.toUpperCase()] ?? null;
};
